import toastComponent from './toast.vue'

let $vm

const toastPlugin = {
	install (vue, pluginOptions = {}) {
		const Toast = vue.extend(toastComponent)

		if (!$vm) {
			$vm = new Toast({
				el: document.createElement('div')
			})
			document.body.appendChild($vm.$el)
		}

		const toast = {
			show (options = {}) {
				if (typeof options === 'string') {
					Object.assign($vm, pluginOptions, {text: options})
				} else if (typeof options === 'object') {
					Object.assign($vm, pluginOptions, options)
				}
				$vm.show = true
			},
			hide () {
				$vm.show = false
			}
		}

		vue.prototype.$toast = toast.show
	}
}

export default toastPlugin



// WEBPACK FOOTER //
// ./src/components/common/toast/index.js